<template>
  <div v-if="configuration.cromite != null" class="hardware-tile cromite-operation">
    <div class="hardware-tile__wrapper-title">
      <div>
        <i class="hardware-tile__title-icon">settings_ethernet</i>
        <h4>Operation</h4>
      </div>
    </div>

    <template v-if="cromiteDetails">
      <div>
        <template v-if="state.ready">
          <HardwareStateComponent :state="3" />
        </template>

        <!-- Old Cromite version -->
        <template v-else-if="cromiteDetails.operation === 1">
          <div class="text-process cromite-operation__title">Column equilibration</div>
        </template>

        <template v-else-if="cromiteDetails.operation === 2">
          <div class="text-process cromite-operation__title">Sampling</div>
        </template>

        <template v-else-if="cromiteDetails.operation === 3">
          <div class="text-yellow cromite-operation__title">Pump purge</div>
        </template>

        <template v-else-if="cromiteDetails.operation === 4">
          <div class="text-yellow cromite-operation__title">Needle cleaning</div>
        </template>

        <template v-else-if="cromiteDetails.operation === 5">
          <div class="text-process cromite-operation__title">Sample injection and run</div>
        </template>

        <template v-else-if="cromiteDetails.operation === 6">
          <div class="text-yellow cromite-operation__title">Refill</div>
        </template>

        <!-- New Cromite version -->
        <template v-else-if="cromiteDetails.operation === 11">
          <div class="text-yellow cromite-operation__title">Needle Filling</div>
        </template>

        <template v-else-if="cromiteDetails.operation === 12">
          <div class="text-yellow cromite-operation__title">Cleaning</div>
        </template>

        <template v-else-if="cromiteDetails.operation === 13">
          <div class="text-yellow cromite-operation__title">Sampling</div>
        </template>

        <template v-else-if="cromiteDetails.operation === 14">
          <div class="text-process cromite-operation__title">Sample injection and run</div>
        </template>

        <template v-else-if="cromiteDetails.operation === 15">
          <div class="text-process cromite-operation__title">Refill</div>
        </template>
      </div>
    </template>

    <template v-if="!injectionInProgress">
      <Btn
        height="s"
        type="primary"
        icon-left="play_arrow"
        :disabled="!device.isMethodCompatible || state.ready !== true"
        class="mt-8 mr-1"
        @click="start"
      >
        Single injection
      </Btn>

      <Btn height="s" icon-left="gradient" class="mt-8" @click="cleanNeedle"> Clean needle </Btn>
    </template>
  </div>
</template>

<script>
  import Base from './Base.vue';
  import Btn from '@/uikitBase/btns/Btn.vue';
  import { cromiteCommands } from '@/constants/hardware/commands';
  import { startInjection } from '@/utils/injectionHelpers';
  import { DEFAULT_VIAL } from '@/constants/hardware/default';

  export default {
    name: 'CromiteOperation',

    components: { Btn },

    extends: Base,

    props: {
      device: {
        type: Object,
        required: true,
      },
    },

    computed: {
      cromiteDetails() {
        return this.state?.cromite_details;
      },
      valveDetails() {
        return this.state?.valve_details;
      },
      injectionInProgress() {
        return this.state.injection_id != null;
      },
    },

    methods: {
      async start() {
        try {
          await startInjection(this.device, DEFAULT_VIAL);
          this.notify('Starting');
        } catch (e) {
          this.notifyError('Can not start injection');
          console.warn('start error', e);
        }
      },
      cleanNeedle() {
        this.$modal.show('dialog', {
          title: 'Are you sure?',
          text: `As soon as the cleaning begins, flow will start coming out of the needle`,
          buttons: [
            {
              title: 'Yes',
              default: true,
              handler: () => {
                this.ws.command('cromite', cromiteCommands.CLEAN_NEEDLE);

                this.$modal.hide('dialog');
              },
              class: 'vue-dialog-button blue-text',
            },
            {
              title: 'No',
              handler: () => {
                this.$modal.hide('dialog');
              },
              class: 'vue-dialog-button red-text',
            },
          ],
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .cromite-operation {
    &__title {
      font-weight: $weight-bold;
      margin-top: 8px;
      margin-bottom: 12px;
    }
  }
</style>
